export class GoDigital {
    store;

    async init(store) {
        this.store = store;
        await this._initTryFreeButton();
    }

    async _initTryFreeButton() {
        const tryFreeButton: HTMLButtonElement = document.querySelector('.go-digital__button--try-free');

        tryFreeButton.addEventListener('click', (event) => {
            this.store.dispatch('modalManagementSystem/addModalWindow', {
                content: 'FormConvertFlow',
            })
        })
    }
}